import constants from '@/common/constants'

export default {
  data() {
    return {
      countries: [],
      countriesSelect: [],
      notificationTypes: [],
      notificationTypesSelect: []
    }
  },
  mixins: [constants],
  methods: {
    isEnded(shipping) {
      return shipping.status === 'DELIVERED' ||
        shipping.status === 'RETURNED' ||
        shipping.status === 'CANCELED'
    },
    setItemsToShow(shippings) {
      if (Array.isArray(shippings)) {
        return shippings.map(x => this.doSetItemsToShow(x))
      } else {
        return this.doSetItemsToShow(shippings)
      }
    },
    doSetItemsToShow(x) {
      if (x.items && x.items.length > 0) {
        x.itemsToShow = x.items.map(y => {
          if (y.item) {
            return this.formatItem(y.item)
          } else {
            return this.formatItem(y)
          }
        })
      } else if (x.meta?.items?.length > 0) {
        x.itemsToShow = x.meta.items.map(y => {
          if (y.item) {
            return this.formatItem(y.item)
          } else {
            return this.formatItem(y)
          }
        })
      } else {
        x.itemsToShow = []
      }
      x.itemsQuantity = x.itemsToShow ? x.itemsToShow.reduce((a, b) => a + (parseInt(b.quantity) || 1), 0) : null
      return x
    },
    formatItem(data) {
      return {
        id: data.id || null,
        reference_code: data.reference_code || this.$gettext('No reference code'),
        description: data.description || this.$gettext('No item description'),
        quantity: data.quantity || 1,
        serial_number: data.serial_number && Array.isArray(data.serial_number) && data.serial_number.length > 0 ? data.serial_number.join(', ') : (data.serialNumbers && Array.isArray(data.serialNumbers) && data.serialNumbers.length > 0 ? data.serialNumbers.join(', ') : null),
        original_serial_number: JSON.parse(JSON.stringify(data.serial_number || null))
      }
    },
    formatShippingPopup(shipping) {
      let infoWindowHtml = ''
      infoWindowHtml += '<p>' + this.$gettextInterpolate(this.$gettext('From: <strong>%{fromAddress}</strong>'), { fromAddress: shipping.from_address || shipping.address_from.formatted_address }) + '</p>'
      infoWindowHtml += '<p>' + this.$gettextInterpolate(this.$gettext('To: <strong>%{toAddress}</strong>'), { toAddress: shipping.to_address || shipping.address_to.formatted_address }) + '</p>'
      infoWindowHtml += shipping.size_id
        ? '<p>' + this.$gettextInterpolate(this.$gettext('Size: <strong>%{size}</strong>'), { size: this.shippingSizes.find(x => x.id === shipping.size_id).name }) + '</p>'
        : ''
      infoWindowHtml += shipping.status_history && shipping.status_history.length > 0
        ? '<p>' + this.$gettextInterpolate(this.$gettext('Current status: <strong>%{status}</strong>'), { status: shipping.status_history[0].status })
        : ''
      infoWindowHtml += shipping.status_history && shipping.status_history.length > 0 && shipping.status_history[0].details?.reason
        ? '<br />' + this.$gettextInterpolate(this.$gettext('Status details: <strong>%{statusDetails}</strong>'), { statusDetails: this.statusReasonsStrings[shipping.status_history[0].details.reason] ? this.statusReasonsStrings[shipping.status_history[0].details.reason] : shipping.status_history[0].details.reason }) + '</p>'
        : ''
      infoWindowHtml += shipping.status_history && shipping.status_history.length > 0
        ? '</p>'
        : ''
      infoWindowHtml += '<p>' + this.$gettextInterpolate(this.$gettext('Last updated: <strong>%{lastUpdated}</strong>'), { lastUpdated: this.moment.utc(shipping.updated_at).tz(this.$tz).format('L LT') }) + '</p>'

      return infoWindowHtml
    },
    checkForAutoExtraCheckpoints(item) {
      let extraCheckpoints = []
      if (item.geo_fences.length > 0) {
        extraCheckpoints = extraCheckpoints.concat(this.checkDistinctExtraPoints(item.geo_fences))
      }
      if (item.geo_lines.length > 0) {
        extraCheckpoints = extraCheckpoints.concat(this.checkDistinctExtraPoints(item.geo_lines))
      }
      if (item.geo_points.length > 0) {
        extraCheckpoints = extraCheckpoints.concat(this.checkDistinctExtraPoints(item.geo_points))
      }
      return extraCheckpoints.filter(Boolean)
    },
    checkDistinctExtraPoints(elements) {
      elements = elements.map(x => {
        if (elements.filter(y => y.geo_type_id === x.geo_type_id).length > 1) {
          x.dupe = true
        } else {
          x.dupe = false
        }
        return x
      })
      return elements
    }
  }
}
